import type { CatalogProperty } from 'src/api/generated';
import { useReferencedProperties } from 'src/modules/shared/hooks/api/catalog/use-referenced-properties';
import { executionPropertyIds } from '../../utils/executions/execution-property-code.util';

/** Load current property labels without modifying recorded execution history. */
export function useExecutionProperties(
  steps: readonly unknown[]
): ReadonlyMap<number, CatalogProperty> {
  return useReferencedProperties(executionPropertyIds(steps)).properties;
}
